module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("A Year of Biblical Womanhood")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "ctl",
    attrs: {
      "id": "p0024-01-0"
    }
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexxiv"
    }
  }, [_c('b', [_vm._v("EVE, THE FALLEN")])])])]), _c('a', {
    attrs: {
      "id": "pagexxiv"
    }
  }, [_c('p', {
    staticClass: "tx0",
    attrs: {
      "id": "p0024-02-1"
    }
  }, [_c('span', [_vm._v("For the first fifty-three verses of the Bible, God does all the talking. “Let there be light,” God says. “Let the land produce living creatures,” God says. “Be fruitful and multiply ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("NASB")]), _vm._v("),” God says.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-03-3"
    }
  }, [_c('span', [_vm._v("It isn’t until the final verses of Genesis 2 that we encounter the first human words of the biblical narrative:"), _c('br'), _c('br')])]), _vm._v(" "), _c('p', {
    staticClass: "txmo",
    attrs: {
      "id": "p0024-04-5"
    }
  }, [_c('span', [_c('i', [_vm._v("“This is now bone of my bones and flesh of my flesh; she shall be called ‘woman,’ for she was taken out of man.”"), _c('br'), _c('br')])])]), _vm._v(" "), _c('p', {
    staticClass: "txmor",
    attrs: {
      "id": "p0024-05-7"
    }
  }, [_c('span', [_c('i', [_vm._v("("), _c('span', {
    staticClass: "small"
  }, [_vm._v("V.")]), _vm._v(" 23)")])]), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-06-8"
    }
  }, [_c('span', [_vm._v("The story of man begins with a love poem about a woman.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-06-9"
    }
  }, [_c('span', [_vm._v("The poem appears in the second creation account of Genesis, in which God forms man from the dust of the earth, fills him with the breath of life, and places him in the garden of Eden with the task of naming the animals. Adam’s assignment reveals the congruous nature of the animal kingdom, and for the first time, the Creator observes a part of creation that is not good.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-07-11"
    }
  }, [_c('span', [_vm._v("“It is not good for the man to be alone,” God says. “I will make a helper suitable for him” (Genesis "), _c('span', {
    staticClass: "small"
  }, [_vm._v("2:1")]), _vm._v("8).")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0024-08-13"
    }
  }, [_c('span', [_vm._v("The Hebrew term "), _c('i', [_vm._v("ezer")]), _vm._v(", or “helper,” is employed elsewhere in Scripture to describe God as an intervener—the helper of the fatherless (Psalm 10:14), King David’s helper and deliverer (Psalm 70:5), Israel’s shield and help (Deuteronomy 33:29). In Genesis 2, it is modified by the word "), _c('i', [_vm._v("kenegdo ")]), _vm._v("to mean “a helper like himself,” or a corresponding character. So, like most good stories, this one begins with both a hero and a heroine.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-P-1"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexxiv"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "id": "pagexxv"
    }
  }, [_vm._v("It is unclear how long our heroic pair revels in this state of divine symmetry, naked and unashamed, before everything falls apart. But at some point a villain appears, promising a better life should they defy the Creator’s single stipulation and eat from the mysterious tree of the knowledge of good and evil. The fruit, described as “pleasing to the eye, and also desirable for gaining wisdom” (Genesis "), _c('span', {
    staticClass: "small"
  }, [_vm._v("3")]), _vm._v(":6), proves too tempting for our heroine. She takes a bite and then gives some to her husband, who also eats. Immediately their eyes are opened, and the first pangs of shame enter human consciousness.")])]), _c('a', {
    attrs: {
      "id": "pagexxv"
    }
  }, [_c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-02-2"
    }
  }, [_c('span', [_vm._v("The man blames the woman, the woman blames the serpent, but God holds all three accountable for the act. As punishment, the serpent must slink through life on its belly in the dirt, and man must toil against stubborn, inhospitable land until his death. To woman belongs pain in childbirth and the grief of being dominated by men.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-03-4"
    }
  }, [_c('span', [_vm._v("“Your desire will be for your husband,” God tells the woman, “and he will rule over you” ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("V")]), _vm._v(". 16).")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-04-6"
    }
  }, [_c('span', [_vm._v("It is within this somber context that man finally assigns woman a name. He calls her Eve, which means “life,” for she is to be “the mother of all living.”")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0025-05-8"
    }
  }, [_c('span', [_vm._v("For centuries, the figure of Eve has been a subject of great interest in Western art, literature, and philosophy. Upon her naked body man has projected his most visceral fears and desires concerning woman, so she is presented as both seductress and mother, noble savage and domesticator, deceiver and the deceived. The Portal of the Virgin at Notre Dame Cathedral includes a stone temptation scene in which the crafty serpent bears the breasts and face of a woman, nearly a mirror image of Eve. This motif repeats itself in medieval iconography, betraying the commonly held view that woman alone was the source of original sin, Eve a sort of biblical Pandora who cracked open the box and brought perpetual shame upon her sex.")])])]), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-02-2"
    }
  }, [_c('a', {
    attrs: {
      "id": "pagexxv"
    }
  }, [_c('span', [_vm._v("“You are the devil’s gateway,” the theologian Tertullian told Christian women. “Do you not know that you are each an Eve? The sentence of God on your sex lives on in this age; the guilt, necessarily, lives on too.”")])]), _c('span', {
    attrs: {
      "href": "#/chapter31#imm4",
      "id": "im4",
      "title": "Link target outside of Sample"
    }
  }, [_c('sup', [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-03-3"
    }
  }, [_c('span', [_vm._v("What we read into the Creation narrative often says as much about us as it says about the text. And for women emerging from the Judeo-Christian tradition, the vilification of Eve has been disastrous. A passage that might challenge readers to aspire to the love and mutuality of Paradise has instead been used for centuries to justify the perpetuation of the curse by forcing women into subordination, with theologians from the apostle Paul to Martin Luther noting somewhat begrudgingly that women are nonetheless necessary for procreation.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-04-5"
    }
  }, [_c('span', [_vm._v("And so, at least symbolically, the blood of Eve courses through each one of her daughters’ veins. We are each associated with life; each subject to the impossible expectations and cruel projections of men; each fallen, blamed, and misunderstood; and each stubbornly vital to the process of bringing something new—perhaps something better—into this world.")])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "p0026-05-7"
    }
  }, [_c('span', [_vm._v("In a sense, Tertullian was right. We are each an Eve.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-606f3edf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter6.vue
// module id = 84
// module chunks = 0